import { AircraftComponentsModel } from '@sd-portal/post-flight/models-aircraft-component';
import { FormControl } from '@angular/forms';

export class AircraftComponentForm {
  postedFlightComponentId: FormControl = new FormControl(0);
  componentId: FormControl = new FormControl(0);
  name: FormControl = new FormControl('');
  durationMinutes: FormControl = new FormControl(null);
  carryOverMinutes: FormControl = new FormControl({ value: 0, disabled: true });
  currentMinutes: FormControl = new FormControl(null);
  cycles: FormControl = new FormControl(null);
  prevCycles: FormControl = new FormControl({ value: 0, disabled: true });
  totalCycles: FormControl = new FormControl(null);
  componentType: FormControl = new FormControl('');
  componentTypeId: FormControl = new FormControl(0);
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(aircraftComponent: AircraftComponentsModel) {
    if (aircraftComponent) {
      this.postedFlightComponentId.setValue(aircraftComponent.postedFlightComponentId);
      this.componentId.setValue(aircraftComponent.componentId);
      this.name.setValue(aircraftComponent.name);
      this.durationMinutes.setValue(aircraftComponent.durationMinutes);
      this.carryOverMinutes.setValue(aircraftComponent.carryOverMinutes);
      this.currentMinutes.setValue(aircraftComponent.currentMinutes);
      this.cycles.setValue(aircraftComponent.cycles);
      this.componentType.setValue(aircraftComponent.componentType);
      this.componentTypeId.setValue(aircraftComponent.componentTypeId);
      this.prevCycles.setValue(aircraftComponent.prevCycles);
      this.totalCycles.setValue(aircraftComponent.totalCycles);
    }
  }
}
